module.exports = __webpack_public_path__ + "static/benefit-1-b7e81d6de65e3ef67b98498a6d971623.svg";